/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from "react";
import "./LoginComponent.css";
import {ReactComponent as LowVisionIcon} from "../../../assets/images/low-vision.svg";
import {useNavigate} from "react-router-dom";
import LoaderComponent from "../../fragments/loader/LoaderComponent";

export default function LoginComponent() {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const navigate = useNavigate();

  function handleUsernameChange(event) {
    setShowErrorMessage(false);
    setEmail(event.target.value);
  }

  function handlePasswordChange(event) {
    setShowErrorMessage(false);
    setPassword(event.target.value);
  }

  async function handleSubmit() {
    setLoading(true);
    setShowErrorMessage(false);

    try {
      const response = await fetch("https://homelab.accesso-italiano.it/api/auth", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-EXT-APP-KEY": "ai-external-app",
          "X-INT-APP-KEY": "ai-internal-app",
        },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        setLoading(false);
        throw new Error("Credenziali non valide");
      }

      const data = await response.json();

      if (data?.token) {
        localStorage.setItem("authToken", data.token);
        navigate("/dashboard");
      } else {
        setLoading(false);
        throw new Error("Token non ricevuto dal server");
      }
    } catch (error) {
      setLoading(false);
      setShowErrorMessage(true);
    }
  }

  function togglePasswordVisibility() {
    setPasswordVisible(!passwordVisible);
  }

  function goToRecovery() {
    navigate("/recovery");
  }

  return (
    <div className="login-component">
     
        {loading ? (
          <div
          className="menu-overlay menu-open"
          >
            <div className={`loader-overlay `}>
              <LoaderComponent />
            </div>
          </div>
        ) : (
          <div className="login-container shadow-drop-center text glass-effect">
            {showErrorMessage && (
              <div className="error-message">Credenziali non valide</div>
            )}
            <div className="login-form">
              <div>
                <label className="login-label">Email</label>
                <br />
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={handleUsernameChange}
                />
              </div>
              <div>
                <label className="login-label">Password</label>
                <br />
                <div className="password-wrapper">
                  <input
                    type={passwordVisible ? "text" : "password"} // Alterna tra "text" e "password"
                    name="password"
                    value={password}
                    onChange={handlePasswordChange}
                    className="password-input"
                  />
                  <button
                    type="button"
                    className="toggle-password-btn"
                    onClick={togglePasswordVisibility}>
                    <LowVisionIcon />
                  </button>
                </div>
              </div>
              <div className="recovery-text">
                <a className="recovery-link" onClick={goToRecovery}>
                  Recupera le credenziali
                </a>
              </div>
              <div>
                <button
                  className="login-button neomorphism-button"
                  onClick={handleSubmit}>
                  Accedi
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
  );
}
